"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDetailVideoPlayer = void 0;
var DetailVideo_init_1 = require("@/pages/detail/states/DetailVideo.init");
exports.defaultDetailVideoPlayer = {
    id: DetailVideo_init_1.defaultDetailVideo.src,
    isMuted: true,
    isPlaying: false,
    targetCurrent: 0,
    currentTime: 0,
    totalTime: 0,
    caption: DetailVideo_init_1.defaultDetailVideo.title,
    title: DetailVideo_init_1.defaultDetailVideo.caption,
    overlayActive: true,
};
